export default "__VITE_ASSET__LYyDht43__"